export default __webpack_public_path__ + "images/R3.793a7f2.png";